import React from 'react';
import { FaClock, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogSection = () => {
  const blogs = [
    {
      id: 1,
      image: "modernconstruction.jpg",
      title: "Modern Construction Techniques: Materials Changing the Industry",
      text: "The construction industry has undergone significant transformations in recent years. With advancements in technology and the introduction of innovative materials, we're seeing faster, safer, and more sustainable building practices emerge.",
      time: "2 Years Ago",
      location: "Industry Insights"
    },
    {
      id: 2,
      image: "efficiency.jpg",
      title: "Streamlining Projects for Faster, Cost-Effective Results",
      text: "Efficient project management is revolutionizing construction timelines and budgets. Learn how modern approaches are delivering quality results in record time while maintaining the highest standards of excellence.",
      time: "1 Year Ago",
      location: "Project Management"
    },
    {
      id: 3,
      image: "greenbuilding.jpg",
      title: "Sustainable Building: The Future of Construction",
      text: "Eco-friendly materials and energy-efficient designs are shaping the future of construction. Discover how sustainable practices are reducing environmental impact while creating healthier living and working spaces.",
      time: "6 Months Ago",
      location: "Sustainability"
    }
  ];

  return (
    <div className="py-2 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-4">
          <span className="text-[#00A3A1] font-medium mb-2 block">Latest Insights</span>
          <h2 className="text-4xl font-bold text-[#063970]">
            Construction Blog & News
          </h2>
          <p className="text-[#000] mt-2 max-w-2xl mx-auto">
            Stay updated with the latest trends, innovations, and best practices in the construction industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group"
            >
              {/* Blog Image */}
              <div className="relative overflow-hidden">
                <img
                  src={`/assets/images/blog/${blog.image}`}
                  alt={blog.title}
                  className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  {/* <span className="bg-[#00A3A1] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {blog.location}
                  </span> */}
                </div>
              </div>

              {/* Blog Content */}
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-4">
                  <div className="flex items-center mr-4">
                    <FaClock className="mr-1 text-[#00A3A1]" />
                    <span>{blog.time}</span>
                  </div>
                  <div className="flex items-center">
                    <FaMapMarkerAlt className="mr-1 text-[#00A3A1]" />
                    <span>{blog.location}</span>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-[#063970] mb-2 group-hover:text-[#00A3A1] transition-colors duration-300">
                  {blog.title}
                </h3>

                <p className="text-[#000] mb-3 leading-relaxed">
                  {blog.text}
                </p>

                <Link to="/blogs">

                  <button className="flex items-center text-[#063970] font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    Read More
                    <FaArrowRight className="ml-2" />
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center my-4">

          <Link to="/blogs">
            <button className="bg-[#00A3A1]  hover:bg-teal-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:-translate-y-1">
              View All Articles
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;